export enum ProtocolName {
  USM = 'Stability Module',
  STACKSWAP = 'Stackswap',
  ALEX = 'ALEX',
  BITFLOW = 'BitFlow'
}